import { Extension } from "..";
import { compact } from "lodash";

import { LinkTools } from "../linkTools/linkToolExtension";
import { LinkPill } from "../nodes/linkPill/linkPill";
import { default as BoldMark } from "./bold";
import { default as CodeMark } from "./code";
import { default as FontMark } from "./colour";
import { default as HighlightMark, SearchHighlightMark } from "./highlight";
import { default as ItalicMark } from "./italic";
import { default as LinkMark } from "./link";
import { default as PlaceholderMark } from "./placeholder";
import { default as StrikeThroughMark } from "./strikethrough";
import { default as UnderlineMark } from "./underline";

export function getAllMarks({
	forSearch = false,
	linkEditable = false,
	placeholderEditable = false,
	linkToolBarAllowEmbeds = false,
	disableLinkToolBar = false,
	disableLinkPill = false,
	linkToolBarCaptureMouseDown = false,
	forStaticDOM = false,
	isPublic = false,
} = {}): Extension[] {
	return compact([
		new CodeMark(),
		forSearch ? new SearchHighlightMark() : new HighlightMark(),
		new BoldMark(),
		new LinkMark({ allowEditing: linkEditable }),
		!disableLinkPill ? new LinkPill({ allowEditing: linkEditable, forStaticDOM, isPublic }) : null,
		new LinkTools({
			allowEditing: linkEditable && !disableLinkToolBar,
			allowEmbeds: linkToolBarAllowEmbeds,
			captureMouseDown: linkToolBarCaptureMouseDown,
		}),
		new FontMark(),
		new ItalicMark(),
		new UnderlineMark(),
		new StrikeThroughMark(),
		new PlaceholderMark({ editable: placeholderEditable }),
	]);
}

export {
	BoldMark,
	ItalicMark,
	UnderlineMark,
	HighlightMark,
	SearchHighlightMark,
	LinkMark,
	StrikeThroughMark,
	CodeMark,
	FontMark,
	PlaceholderMark,
};
